const FREE_EMAIL_DOMAINS = new Set([
	"aol.com",
	"fastmail.com",
	"gmail.com",
	"googlemail.com",
	"gmx.com",
	"hey.com",
	"hotmail.com",
	"icloud.com",
	"inbox.com",
	"live.com",
	"mac.com",
	"mail.com",
	"me.com",
	"msn.com",
	"outlook.com",
	"proton.me",
	"protonmail.com",
	"tutanota.com",
	"yahoo.com",
	"yandex.com",
	"zoho.com",
]);

export function parseEmailDomain(email: string): string | null {
	const trimmed = email.trim().toLowerCase();
	const parts = trimmed.split("@");
	if (parts.length !== 2) {
		return null;
	}
	return parts[1]?.trim().toLowerCase() ?? null;
}

export function isBusinessEmail(email: string): boolean {
	const domain = parseEmailDomain(email);
	if (!domain) {
		return false;
	}
	return !FREE_EMAIL_DOMAINS.has(domain);
}

export function inferCompanyNameFromBusinessEmail(
	email: string,
): string | null {
	if (!isBusinessEmail(email)) {
		return null;
	}
	const domain = parseEmailDomain(email);
	if (!domain) {
		return null;
	}
	const labels = domain.split(".").filter(Boolean);
	if (labels.length === 0) {
		return null;
	}
	let registrableLabel = labels[0] ?? "";
	if (
		labels.length >= 3 &&
		labels[labels.length - 2] === "co" &&
		labels[labels.length - 1] === "uk"
	) {
		registrableLabel = labels[labels.length - 3] ?? registrableLabel;
	}
	if (!registrableLabel) {
		return null;
	}
	return registrableLabel.charAt(0).toUpperCase() + registrableLabel.slice(1);
}
